import { GetReactionIcon } from "../../../../Shared/Components/Tippspiel/Reactions/ReactionsIconsFactory";
import {
    ReactionTab,
    ReactionTabsContainer,
    ReactionTypeTypography,
} from "./ReactionsListModal.styles";
import { Tabs, TabsProps } from "@mui/material";
import { Reactions } from "./ReactionsListModal.types";

export function ReactionsListTabs({
    onChange,
    tabIndex,
    tabs,
}: TabsProps & { tabIndex: number; tabs: Reactions[] }) {
    return (
        <ReactionTabsContainer>
            <Tabs value={tabIndex} onChange={onChange}>
                {tabs.map((tab) => (
                    <ReactionTab
                        key={tab.type}
                        icon={
                            tab.type === "all" ? (
                                <></>
                            ) : (
                                <GetReactionIcon
                                    reactionName={tab.type}
                                    sx={{
                                        width: "20px",
                                        height: "20px",
                                    }}
                                />
                            )
                        }
                        label={
                            <>
                                {tab.type === "all" ? (
                                    <ReactionTypeTypography>
                                        Alle
                                    </ReactionTypeTypography>
                                ) : (
                                    <></>
                                )}
                                <ReactionTypeTypography>
                                    {tab.totalCount.toLocaleString("de-DE")}
                                </ReactionTypeTypography>
                            </>
                        }
                    />
                ))}
            </Tabs>
        </ReactionTabsContainer>
    );
}
